import Lenis from "lenis";

export const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });

export function startLenis() {
  let rafId;
  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(rafId);
  };
}

export function scrollToSection(selector) {
  lenis.scrollTo(selector, { duration: 1.6 });
}
